import React from 'react';
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';

export default class HomePage extends React.Component {

  render() {

    return (
      <div className='container'>
        <div className="container2">
          <div className="header">
            <div className="menu1">
              <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
            </div>
            <div className="menu2"><a href="#setup">Setup</a></div>
            <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
            <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
            <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
          </div>
          <div className="row">
            <center>
              <div className="col-12 col-s-12">
                <div className="col-12 col-s-12"><img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
                  <div className="col-12 col-s-12">
                    <p className="text_catch1">Build customer rapport by playing songs<br></br>your customers know and love</p>
                    <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
                    <table className="table1">
                      <tbody>
                      <tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img" src="album_covers.jpg" alt="" /></div></td>
                      <td className="td6">
                        <p className="text_how_it_works">Millions of Your Favorite Songs - <br />Coming Soon</p>
                        <p className="text_how_it_works2">With over 10 million licensed songs, the Apollo AI Streaming Music Player plays
                  the music your customers like most.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>

                        <tr>
                          <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="how_it_works.png" alt="" /></div></td>
                          <td className="td6">
                            <p className="text_how_it_works">Build Customer Rapport</p>
                            <p className="text_how_it_works2">The Apollo Music Player is the only music player that uses computer vision and artificial
                            intelligence to play songs tailored to your customers in your location in real time.
                            The Apollo Music Player determines the age and gender of your
                           customers and selects the number one song from the current week when they were 14 years old.</p>
                            <p className="text_how_it_works2">Your establishment will always play your customer's favorite music.</p>
                          </td>
                        </tr>
						<br></br><br></br><br></br><br></br>
						
						                      <tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="grandparents_shopping_2.png" width="200" alt="" /></div></td>
                      <td className="td6"><br></br><br></br><br></br><br></br>
                        <p className="text_how_it_works2">Bob and Mary are shopping with their grandchildren. The music system plays them each a song from when they were young.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>
					
					<tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="dashboard_04232021.png" width="200" alt="" /></div></td>
                      <td className="td6"><p className="text_how_it_works">More Than Just A Music Player</p><br></br>
                        <p className="text_how_it_works2"><b>Customer Analytics</b> - Get detailed demographical information on your customers, such as age, gender and emotion.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>
					
					<tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="targetted_ad1.jpg" width="200" alt="" /></div></td>
                      <td className="td6"><p className="text_how_it_works"></p><br></br>
                        <p className="text_how_it_works2"><b>Targeted Advertising</b> - advertise to customers in real time.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>

					<tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="targetted_ad2.jpg" width="200" alt="" /></div></td>
                      <td className="td6"><p className="text_how_it_works"></p><br></br>
                        <p className="text_how_it_works2"><b></b></p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>
					
					
					<tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="POS_data_example.png" width="200" alt="" /></div></td>
                      <td className="td6"><p className="text_how_it_works"></p><br></br>
                        <p className="text_how_it_works2"><b>Sales Analytics</b> - Merge customer information with point of sales data to determine what type of customers are purchasing which products.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>
					
					<tr>
                      <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="song_list_04232021.png" width="200" alt="" /></div></td>
                      <td className="td6"><br></br><br></br><br></br><br></br>
                        <p className="text_how_it_works2">Get detailed song play lists so you know what songs were played at each location.</p>
                      </td>
                    </tr>
					<br></br><br></br><br></br><br></br>
					
					
					

                        <tr>
                          <td className="td5"><div className="col-12 col-s-12"><img className="center_img, photo1" src="setup2.jpg" alt="" /></div></td>
                          <td id="setup" className="td6">
                            <p className="text_how_it_works">Setup</p>
                            <p className="text_how_it_works2">Setup is easy. Just connect the webcam (included), audio, Internet and power
                          and your Apollo AI Streaming Music Player is ready to play your customer's favorite music.</p>
                          </td>
                        </tr>


					
                      </tbody>
                    </table>
                    <br></br><br></br><br></br><br></br>
                  </div>
                </div>
              </div>
            </center>
          </div>
        </div>
        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
          <p className="text3">Pat. No. 11,232,469</p>
        <br></br>
        </div>
      </div>
    );
  }
}